import { create } from 'zustand';

interface WhiteboardSyncState {
  lastCanvasJson: string | null;
  lastCanvasDataUrl: string | null;
  setLastCanvasJson: (json: string | null) => void;
  setLastCanvasDataUrl: (url: string | null) => void;
  getLastCanvasJson: () => string | null;
}

export const useWhiteboardSyncStore = create<WhiteboardSyncState>((set, get) => ({
  lastCanvasJson: null,
  lastCanvasDataUrl: null,
  setLastCanvasJson: (json) => set({ lastCanvasJson: json }),
  setLastCanvasDataUrl: (url) => set({ lastCanvasDataUrl: url }),
  getLastCanvasJson: () => get().lastCanvasJson,
}));
